export default __webpack_public_path__ + "static/media/MapChart.f8d7e794.png";